import React from 'react';
import PropTypes from 'prop-types';

import { Label } from '@domain/components';

import classnames from 'classnames';
import { styled } from '@mui/material/styles';
import { Colors } from '@domain/theming';
import { isMobile } from 'react-device-detect';
import { useScaling } from '@domain/hooks';

const StyledInputFile = styled('div', {
  shouldForwardProp: (propName) => !propName.startsWith('$')
})`
  width: 100%;
  padding-top: 30%;
  margin-top: 15px;
  margin-bottom: 12px;
  position: relative;
  .input--file {
    display: none;
    z-index: 1;
  }
  .input--file__label--small {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url('/img/svg/uploader-border-small.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-clip: content-box;
    color: ${Colors.BLACK};
    text-align: center;
    width: 100%;
    height: 100%;
    font-weight: normal;
    cursor: pointer;
    .label {
      font-weight: normal;
      font-size: ${props => !isMobile ? props.$scaling.textSize(14) : props.$scaling.textSizeMobile(14)}px;
      line-height: ${props => !isMobile ? props.$scaling.textSize(18) : props.$scaling.textSizeMobile(18)}px;
      b {
        font-size: ${props => !isMobile ? props.$scaling.textSize(16) : props.$scaling.textSizeMobile(16)}px;
        line-height: ${props => !isMobile ? props.$scaling.textSize(20) : props.$scaling.textSizeMobile(20)}px;
        display: block;
        margin-bottom: 6px;
      }
    }
    .text {
      max-width: 83%;
    }
    svg.svg-border {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      rect {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        fill: none;
        stroke: ${Colors.BLACK};
        stroke-width: 1;
        stroke-dasharray: 8, 8;
      }
    }
  }
  .input-file--icon {
    color: ${Colors.WHITE};
    width: 40px;
    height: 40px;
    margin-bottom: 12px;
  }
  .screen-desktop & {
    margin-bottom: ${props => props.$scaling.scaleUpTo4K(12)}px;
    margin-top: ${props => props.$scaling.scaleUpTo4K(15)}px;
    .input-file--icon {
      width: ${props => props.$scaling.scaleUpTo4K(40)}px;
      height: ${props => props.$scaling.scaleUpTo4K(40)}px;
    }
  }
  @media screen and (max-width: 360px) {
    padding-top: 66.66%;
    .input--file__label--small {
      background-image: url('/img/svg/uploader-border-sm.svg');
    }
  }
  .theme-custom & {
    .input-file--icon {
      title + path:first-of-type {
        fill: ${props => props.theme.colors.primary};
      }
    }
    .subtitle-text {
      color: ${props => props.theme.colors.primary};
    }
  }
  .screen-ie &, .screen-edge & {
    .input--file__label--small {
      background-size: cover
    }
  }
`;
function InputFile({ onChange, autoFocus, ref, inputRef, children, isDragging, multiple = true, accepts }) {
  const scaling = useScaling();
  const labelClassName = classnames('input--file__label--small', {
    'input--file__label--dragging': isDragging
  });

  return (
    <StyledInputFile className="input--file__container--small" $scaling={scaling}>
      <Label className={labelClassName} htmlFor="input-file">
        {React.Children.toArray(children)}
      </Label>
      <input
        className="input--file"
        type="file"
        name="photos"
        onChange={onChange}
        id="input-file"
        {...(accepts ? { accept: accepts } : {})}
        {...(multiple ? { multiple: true } : {})}
        autoFocus
        ref={inputRef}
      />
    </StyledInputFile>
  );
}

InputFile.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default InputFile;
